import {ACTION_CODE} from './_actionCode';
import {ExpenseAttachmentService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';
const FUNCTION_CODE = 'CREATE_EXPENSE_ATTACHMENT';

export async function getAllExpenseAttachments(userData: Record<string, any>, reportId: string) {
    try {
        LoggerService.logInfo('Action - getAllExpenseAttachments - Start');

        const getAllExpenseAttachmentResult = await ExpenseAttachmentService.getAllExpenseAttachments(userData, reportId);

        LoggerService.logInfo('Action - getAllExpenseAttachments - End - Success');

        return ResultModel.newSuccessResult(getAllExpenseAttachmentResult);
    }
    catch (error) {
        LoggerService.logInfo('Action - getAllExpenseAttachments - End - Error');

        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
